module.exports = __webpack_public_path__ + "static/media/Refresh.0d0ed892.svg";